module.exports = __webpack_public_path__ + "fontawesome-webfont-57430a4d5a9f00e16a0affd19b750632.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 77
// module chunks = 0 1